<template>
    <div>

        <div class="absolute z-40" v-if="!excluded_routes.includes($route.name)" style="bottom: 11rem; left: 2rem;">
            <img :src="getImage('chinese')" style="width: 20rem;">
        </div>

        <div class="absolute z-40" v-if="!excluded_routes.includes($route.name)" style="top: 0; left: 0;">
            <img :src="getImage('fan')" style="width: 15rem;">
        </div>

        <!-- <div class="absolute z-60" v-if="$route.name === 'start-page'" style="top: -0.5rem; left: 50%; transform: translateX(-50%);">
            <img :src="getImage('lunar')" style="width: 38rem;">
        </div> -->

        <div class="absolute z-60" v-if="$route.name === 'start-page'" style="bottom: -20rem; right: -8rem;">
            <img :src="getImage('dragon-2')"  class="papsi-cloud" style="width: 50rem;">
        </div>

        <div class="absolute z-60" v-if="$route.name === 'start-page'" style="bottom: -23rem; left: -20rem;">
            <img :src="getImage('dragon-1')"  class="papsi-cloud" style="width: 60rem;">
        </div>


        <div  v-if="$route.name !== 'kiosk-login-page'" :class="{'w-1/3': true, 'w-full': ['start-page', 'choose-lang-page'].includes($route.name)}" class="fixed h-full pointer-events-none overflow-hidden" style="z-index: 51; top: 0; left: 0;">
            <div class="papsi-heart" v-for="flake in snowflakes" :key="flake.id" :style="generateFlakeStyle(flake.id)">
            </div>
        </div>
        
    </div>
</template>

<script>
import mixin from "@/mixins/controls.js";

export default {
    mixins: [mixin],
    props: {
        density: {
            type: Number,
            default: 15,
        },
    },
    data() {
        return {
            snowflakes: [],
            excluded_routes: [
                "start-page",
                "error",
                "kiosk-login-page",
                "selection-page",
                "choose-lang-page",
            ],
        };
    },
    mounted() {
        this.generateSnowflakes();
    },
    methods: {
        generateSnowflakes() {
            for (let i = 0; i < this.density; i++) {
                this.snowflakes.push({ id: i });
            }
        },
        generateFlakeStyle(index) {
            const sizes = [
                { width: "15px", height: "15px" },   // Adjust size for hearts
                { width: "20px", height: "20px" },
                { width: "25px", height: "25px" },
                { width: "30px", height: "30px" },
            ];
            const size = sizes[index % sizes.length];
            return {
                "--random": Math.random(),
                width: size.width,
                height: size.height,
                animationDuration: `${12 + Math.random() * 3}s`,
                animationDelay: `${Math.random() * 10}s`,
                left: `${Math.random() * 100}%`,
            };
        },
    },
};
</script>

<style scoped>

.papsi-cloud {
    animation: enlarge-shrink 1.5s infinite;
    /* 2s duration, infinite loop */
}

.papsi-heart {
    position: absolute;
    top: -10%;
    background-image: url('https://resource.pafcpic.net/assets/pia/images/themes/papsi_sparkle.png');  /* Heart image URL */
    background-size: contain;  /* Ensure the heart is scaled correctly */
    background-repeat: no-repeat;
    animation: fall linear infinite;
    opacity: 0.7;
}

/* Snowflake falling animation */
@keyframes fall {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(100vh);
    }
}

@keyframes enlarge-shrink {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
        /* Enlarge the image */
    }

    100% {
        transform: scale(1);
        /* Shrink back to original size */
    }
}

</style>